// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7086) return "static/chunks/7086.0007612311f9f829.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"7999":"9ac6c4499b4055d7","9766":"8fc28d01d2a72e53"}[chunkId] + ".js";
};